<template>
    <CustomPage key-id="main" />
</template>

<script>
import CustomPage from './_.vue'
import { GET_META } from '@@/graphQL/web'

export default {
  name: 'IndexPage',

  components: {
    CustomPage
  },

  layout: 'custom',

  data: () => ({
    metaBySlug: {
      title: '',
      description: '',
      alt: ''
    }
  }),

  head () {
    return {
      title: this.metaBySlug?.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaBySlug?.description
        }
      ]
    }
  },

  apollo: {
    metaBySlug: {
      query: GET_META,
      variables () {
        return {
          // @ts-ignore
          route: 'main',
          siteCode: this.$store.state.siteCode,
          // @ts-ignore
          slug: ''
        }
      }
    }
  }
}
</script>
